<template>
  <div class="statistics-section">
    <div class="container general-section">

      <h1>
        <font-awesome-icon icon="chart-line" />
        Statistik
      </h1>
    </div>

    <market-statistics/>

  </div>
</template>

<script>

  import MarketStatistics from "./Market/Index"
  export default {
    name: "Statistics",
    components: {MarketStatistics},
    metaInfo() {
      return {
        title: 'Statistik'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Index.vue